import React from 'react';
import './CaHowItWorks.css';

const CaHowItWorks = () => {
  return (
    <div
      className="Ca-how-it-works-wrapper"
      style={{
        '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
      }}
    >
      <section className="Ca-how-it-works" id="how-it-works">
        <div className="Ca-how-it-works__container">
          {/* Badge */}
          <div className="Ca-how-it-works__badge">HOW IT WORKS</div>

          {/* Main Section Title */}
          <h2 className="Ca-how-it-works__title">
            How To Start Online Quran Classes In 3 Simple Steps
          </h2>

          {/* Steps Row */}
          <div className="Ca-how-it-works__steps-container">
            {/* Step 1 */}
            <div className="Ca-how-it-works__step">
              <div className="Ca-how-it-works__icon-wrapper">
                <svg className="Ca-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <h3 className="Ca-how-it-works__step-num">Step 1</h3>
              <h4 className="Ca-how-it-works__step-title">Book Your Free Trial</h4>
              <p className="Ca-how-it-works__step-desc">
                Fill out our simple form with your name, location, course interest, and preferred time. It takes less than 2 minutes.
              </p>
            </div>

            {/* Step 2 */}
            <div className="Ca-how-it-works__step">
              <div className="Ca-how-it-works__icon-wrapper">
                <svg className="Ca-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <h3 className="Ca-how-it-works__step-num">Step 2</h3>
              <h4 className="Ca-how-it-works__step-title">Get Matched with Your Tutor</h4>
              <p className="Ca-how-it-works__step-desc">
                We match you or your child with a certified tutor based on your level, gender preference, and schedule. Your first session is arranged within 24 hours.
              </p>
            </div>

            {/* Step 3 */}
            <div className="Ca-how-it-works__step">
              <div className="Ca-how-it-works__icon-wrapper">
                <svg className="Ca-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
              <h3 className="Ca-how-it-works__step-num">Step 3</h3>
              <h4 className="Ca-how-it-works__step-title">Start Learning & Track Progress</h4>
              <p className="Ca-how-it-works__step-desc">
                Attend your live one-on-one sessions, receive feedback after every class, and track measurable progress through our structured curriculum. Your journey begins on Day 1.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaHowItWorks;
